const POLL_INTERVAL_MS = 15000;

export default async (module_id,actualRoom,settings) =>
{
    console.log('%c 📺 Stream Module Loaded! ', 'background: #222; color: #bada55');

    // The initial markup is already server-rendered with the correct active_source
    // (see module.blade.php), so we seed our state from it instead of touching the
    // DOM here - re-rendering on load would just replace correct SSR content with
    // an identical copy and needlessly reload the iframe/stream.
    let currentSettings = settings;
    let currentLanguage = 'de';

    const viewerId = (window.crypto && window.crypto.randomUUID)
        ? window.crypto.randomUUID()
        : `${Date.now()}-${Math.random().toString(16).slice(2)}`;

    const data = await (await fetch(`/room/${actualRoom}/module/${module_id}/api?action=metadata`)).json();
    currentSettings = data.settings;
    preloadImages(currentSettings);

    [].forEach.call(data.user.groups, function(group) {
      if(data.group_everyone === group["id"])
      {
        Echo.channel(`room.${actualRoom}.module.${module_id}.group.${group["id"]}.settings`)
        .listen('ModuleSettingsUpdate', async (event) => { handleModuleUpdate(event) })
        .listen('.Modules\\Stream\\Events\\StreamSourceUpdate', async (event) => { handleSourceSwitch(event) })
        .listen('.Modules\\Stream\\Events\\OverlayUpdate', async (event) => { handleOverlayUpdate(event) });
      }
      else {
        Echo.private(`room.${actualRoom}.module.${module_id}.group.${group["id"]}.settings`)
        .listen('ModuleSettingsUpdate', async (event) => { handleModuleUpdate(event) })
        .listen('.Modules\\Stream\\Events\\StreamSourceUpdate', async (event) => { handleSourceSwitch(event) })
        .listen('.Modules\\Stream\\Events\\OverlayUpdate', async (event) => { handleOverlayUpdate(event) });
      }
  });

  async function handleModuleUpdate(event)
   {
       currentSettings = event.settings;
       preloadImages(currentSettings);
       renderContent(currentSettings);
   }

   function handleSourceSwitch(event)
   {
       currentSettings = { ...currentSettings, active_source: event.active_source };
       renderContent(currentSettings);
   }

   function handleOverlayUpdate(event)
   {
       currentSettings = { ...currentSettings, overlay: event.overlay, overlay_text: event.overlay_text };
       renderContent(currentSettings);
   }

   function imageUrl(filename)
   {
       return `/room/${actualRoom}/module/${module_id}/public?action=image&name=${encodeURIComponent(filename || '')}`;
   }

   // Resolves which of the 6 concrete fields (matching the operator dashboard's
   // multiview tiles) this viewer is currently being shown - used both for
   // rendering and for the viewer-count heartbeat, so both stay in sync.
   function resolveField(settings, language)
   {
       const activeSource = settings.active_source || 'primary';

       if(activeSource === 'poster') return 'poster_image';
       if(activeSource === 'error') return 'error_image';
       if(activeSource === 'backup') return language === 'en' ? 'stream_backup_url2' : 'stream_backup_url';
       return language === 'en' ? 'stream_url2' : 'stream_url';
   }

   // Preloads poster/error images into the browser cache as soon as their
   // filename is known - not just when that source becomes active - so
   // switching to them later (e.g. during an incident) shows instantly
   // instead of flashing empty while the image is fetched.
   function preloadImages(settings)
   {
       [settings.poster_image, settings.error_image].forEach(function(filename){
           if(!filename) return;
           new Image().src = imageUrl(filename);
       });
   }

   // Only touches the DOM (and thus reloads the iframe) when the resolved
   // field's value actually changed - a settings update unrelated to the
   // currently shown source (e.g. someone uploading a poster image while the
   // live stream is on screen) must not interrupt a running stream.
   function updateMedia(container, value, isImage)
   {
       const key = (isImage ? 'image:' : 'iframe:') + (value || '');
       if(container.dataset.mediaKey === key) return;
       container.dataset.mediaKey = key;

       if(!value)
       {
           container.innerHTML = '';
       }
       else if(isImage)
       {
           container.innerHTML = '<div class="poster_wrapper"><img src="'+imageUrl(value)+'" alt=""></div>';
       }
       else
       {
           container.innerHTML = '<div class="iframe_wrapper"><iframe id="iframe_livestream" width="1920" height="1080" src="'+value+'" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe></div>';
       }
   }

   function renderContent(settings)
   {
       const content = document.querySelector(`[data-module-relation-id='${module_id}'] [data-module-content]`);
       if(!content) return;

       if(settings.enabled === "0")
       {
          content.innerHTML = "";
          return;
       }

       // A persistent skeleton is created once; later renders only patch the
       // parts that actually changed instead of tearing down and rebuilding
       // everything (which would reload the iframe on every render pass). The
       // overlay lives as a sibling of the actual media content (not inside
       // it) so updateMedia() replacing the iframe/image never wipes it out.
       if(!content.querySelector('[data-stream-media]'))
       {
           content.innerHTML = '<div data-stream-headline></div>'
               + '<div data-stream-description></div>'
               + '<div data-stream-media>'
               + '<div data-stream-media-content></div>'
               + '<div class="stream_overlay" data-stream-overlay hidden><span></span></div>'
               + '</div>'
               + '<div data-stream-controls class="pt-1"></div>';
       }

       const activeSource = settings.active_source || 'primary';
       const field = resolveField(settings, currentLanguage);
       const isImage = activeSource === 'poster' || activeSource === 'error';

       content.querySelector('[data-stream-headline]').innerHTML = settings.headline !='' ? "<h2>"+settings.headline+"</h2>" : "";
       content.querySelector('[data-stream-description]').innerHTML = settings.description !='' ? "<p>"+settings.description+"</p>" : "";

       updateMedia(content.querySelector('[data-stream-media-content]'), settings[field], isImage);

       const overlay = content.querySelector('[data-stream-overlay]');
       const overlayText = settings.overlay_text || '';
       const overlayActive = !!settings.overlay && overlayText !== '';
       overlay.hidden = !overlayActive;
       overlay.querySelector('span').textContent = overlayText;

       const controls = content.querySelector('[data-stream-controls]');
       controls.innerHTML = isImage ? '' : (''
           + '<button id="btnDE" class="btn '+(currentLanguage === 'de' ? 'btn-secondary' : 'btn-outline-secondary')+'" onclick="window.streamSwitchLanguage(\'de\')"><i class="fa-solid fa-headphones"></i> Deutsch</button>'
           + '<button id="btnEN" class="btn '+(currentLanguage === 'en' ? 'btn-secondary' : 'btn-outline-secondary')+'" onclick="window.streamSwitchLanguage(\'en\')"><i class="fa-solid fa-headphones"></i> English</button>');
   }

   function sendViewerHeartbeat()
   {
       fetch(`/room/${actualRoom}/module/${module_id}/api?action=viewer_heartbeat`, {
           method: 'POST',
           headers: { 'Content-Type': 'application/json' },
           body: JSON.stringify({ viewer_id: viewerId, field: resolveField(currentSettings, currentLanguage) })
       }).catch(() => {});
   }

   window.streamSwitchLanguage = function(language)
   {
       currentLanguage = language;
       renderContent(currentSettings);
   };

   sendViewerHeartbeat();

   setInterval(async () => {
       try {
           const polled = await (await fetch(`/room/${actualRoom}/module/${module_id}/api?action=metadata`)).json();
           if(JSON.stringify(polled.settings) !== JSON.stringify(currentSettings))
           {
               currentSettings = polled.settings;
               renderContent(currentSettings);
           }
       } catch(e) {
           console.log(e);
       }

       sendViewerHeartbeat();
   }, POLL_INTERVAL_MS);
};
